import Vue from "vue";

Vue.prototype.$seasontag = ["summer", "winter", "no_seas"];
